import { OptimizationOptions } from '@/services/bayesianApi/optimizationModels'

export const optionLabels: Record<keyof OptimizationOptions, string> = {
  max_time_minutes: 'Max time (hours)',
  max_iteration: 'Apply result after this many iterations',
  tolerance: 'Optimizer algorithm tolerance',
  step_size: 'Step size',
  randomize_initial_probabilities: 'Randomize initial CPTs',
  number_of_runs: 'Number of runs',
  inference_algorithm: 'Optimization algorithm',
  run_optimization_analysis: 'Run optimization analysis',
}
